import { Injectable } from '@angular/core';
import { Resolve, Router } from '@angular/router';
import { AdaptorData } from 'qp-ui-interface';
import { Observable, from, of } from 'rxjs';
import { StorefrontService } from '../../storefront/storefront.service';
import { TabService } from '../services/tabs/tab.service';

@Injectable()
export class PlayerResolver implements Resolve<unknown> {
  dataFromStorefront: any;

  constructor(private router: Router, private storefrontService: StorefrontService, private tabService: TabService) {}
  resolve(): Observable<any> {
    const { state } = this.router.getCurrentNavigation().extras;
    if (state?.type && state?.id) {
      const { id } = state;
      let { type } = state;
      type = type === 'webseries' ? 'webepisode' : type;
      // LIVE CONTENT
      if (type === 'liveevent' || type === 'livechannel' || type === 'channel') {
        // FOR LIVE EVENT WE ALREADY HAVE THE DATA FROM THE STOREFRONT
        return of({});
      } else {
        const adaptorData: AdaptorData = {
          resourceType: type,
          resourceId: id,
          tabId: this.tabService.currentTabId,
          tabName: this.tabService.getCurrentTab()?.name,
        };
        const resouceVm = this.storefrontService.fetchResourceDetails(adaptorData);
        return from(resouceVm);
      }
    }
    return of({});
  }
}
